import React from 'react';

import Box from '@mui/material/Box';

import { C, FONT, COUNT_CAP } from './tokens';

// Pending work on a nav entry (Tareas, Traslados), in warning rather than error: a queue with items
// in it is the normal state of a shift. Expanded it is a chip after the label; collapsed, a bubble
// over the icon, which is the only place left once the label is gone.
const NavCount = ({ count, variant }) => {
  if (!count || count <= 0) return null;

  const label = count > COUNT_CAP ? `${COUNT_CAP}+` : String(count);

  const base = {
    font: `700 9px/1 ${FONT}`,
    color: '#fff',
    bgcolor: C.warning,
    borderRadius: '999px',
    display: 'grid',
    placeItems: 'center',
    flex: 'none',
  };

  if (variant === 'bubble') {
    return (
      <Box
        component="span"
        aria-label={`${label} pendientes`}
        sx={{
          ...base,
          position: 'absolute',
          top: 2,
          right: 2,
          minWidth: 16,
          height: 16,
          px: '4px',
          // The rail is the bubble's backdrop, so the ring that lifts it off the
          // icon has to be painted in the rail's own colour.
          boxShadow: `0 0 0 2px ${C.ink}`,
        }}
      >
        {label}
      </Box>
    );
  }

  return (
    <Box component="span" aria-label={`${label} pendientes`} sx={{ ...base, minWidth: 20, height: 17, px: '6px' }}>
      {label}
    </Box>
  );
};

export default NavCount;
